module.exports = __webpack_public_path__ + "static/media/lobster.9858076f.png";